import i18nConfig from "@/i18nConfig";
import { resources as allResources } from "blockly-turtle-common/i18n";
import { createInstance, i18n, Resource } from "i18next";
import { initReactI18next } from "react-i18next/initReactI18next";

export default async function initTranslations(
    locale: string,
    namespaces: string[],
    i18nInstance?: i18n,
    resources?: Resource,
) {
    i18nInstance = i18nInstance || createInstance();

    i18nInstance.use(initReactI18next);

    if (!resources) {
        // i18nInstance.use(
        //     resourcesToBackend(
        //         (language: string, namespace: string) =>
        //             import(`blockly-turtle-common/i18n/${language}/${namespace}.json`)
        //     )
        // );
        // resources = allResources;
        resources = allResources;
    }

    await i18nInstance.init({
        lng: locale,
        resources,
        fallbackLng: i18nConfig.defaultLocale,
        supportedLngs: i18nConfig.locales,
        defaultNS: namespaces[0],
        fallbackNS: namespaces[0],
        ns: namespaces,
        preload: [],
    });

    return {
        i18n: i18nInstance,
        resources: i18nInstance.services.resourceStore.data,
        t: i18nInstance.t,
    };
}
